import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CustomerProfile = ({ customer }) => {
  const [activeTab, setActiveTab] = useState('contact');
  const [isEditing, setIsEditing] = useState(false);

  const tabs = [
    { id: 'contact', label: 'Contacto', icon: 'Phone' },
    { id: 'billing', label: 'Facturación', icon: 'CreditCard' },
    { id: 'delivery', label: 'Entrega', icon: 'Truck' },
    { id: 'financial', label: 'Financiero', icon: 'Euro' }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'Activo':
        return 'bg-success-100 text-success border-success-200';
      case 'Pendiente':
        return 'bg-warning-100 text-warning border-warning-200';
      case 'Inactivo':
        return 'bg-error-100 text-error border-error-200';
      default:
        return 'bg-secondary-100 text-text-secondary border-secondary-200';
    }
  };

  const getRelationshipColor = (status) => {
    switch (status) {
      case 'Cliente Premium':
        return 'bg-warning-100 text-warning border-warning-200';
      case 'Cliente Frecuente':
        return 'bg-primary-100 text-primary border-primary-200';
      case 'Cliente Nuevo':
        return 'bg-info-100 text-info border-info-200';
      default:
        return 'bg-secondary-100 text-text-secondary border-secondary-200';
    }
  };

  const renderContactTab = () => (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Persona de Contacto
          </label>
          <div className="p-3 bg-secondary-50 rounded-md">
            <p className="text-sm text-text-primary">{customer.contactPerson}</p>
          </div>
        </div>
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Empresa
          </label>
          <div className="p-3 bg-secondary-50 rounded-md">
            <p className="text-sm text-text-primary">{customer.company}</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Email
          </label>
          <div className="p-3 bg-secondary-50 rounded-md flex items-center justify-between">
            <p className="text-sm text-text-primary">{customer.email}</p>
            <Icon name="Mail" size={16} className="text-text-muted" />
          </div>
        </div>
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Teléfono
          </label>
          <div className="p-3 bg-secondary-50 rounded-md flex items-center justify-between">
            <p className="text-sm text-text-primary">{customer.phone}</p>
            <Icon name="Phone" size={16} className="text-text-muted" />
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-body-medium text-text-secondary mb-1">
          Ubicación
        </label>
        <div className="p-3 bg-secondary-50 rounded-md flex items-center justify-between">
          <p className="text-sm text-text-primary">{customer.location}</p>
          <Icon name="MapPin" size={16} className="text-text-muted" />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Industria
          </label>
          <div className="p-3 bg-secondary-50 rounded-md">
            <p className="text-sm text-text-primary">{customer.industry}</p>
          </div>
        </div>
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Región
          </label>
          <div className="p-3 bg-secondary-50 rounded-md">
            <p className="text-sm text-text-primary">{customer.region}</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderBillingTab = () => (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-body-medium text-text-secondary mb-2">
          Dirección de Facturación
        </label>
        <div className="p-4 bg-secondary-50 rounded-md space-y-2">
          <p className="text-sm text-text-primary">{customer.billingAddress.street}</p>
          <p className="text-sm text-text-primary">
            {customer.billingAddress.postalCode} {customer.billingAddress.city}
          </p>
          <p className="text-sm text-text-primary">{customer.billingAddress.country}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Condiciones de Pago
          </label>
          <div className="p-3 bg-secondary-50 rounded-md">
            <p className="text-sm text-text-primary">{customer.paymentTerms}</p>
          </div>
        </div>
        <div>
          <label className="block text-sm font-body-medium text-text-secondary mb-1">
            Límite de Crédito
          </label>
          <div className="p-3 bg-secondary-50 rounded-md">
            <p className="text-sm font-body-semibold text-success">{customer.creditLimit}</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDeliveryTab = () => (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-body-medium text-text-secondary mb-2">
          Dirección de Entrega
        </label>
        <div className="p-4 bg-secondary-50 rounded-md space-y-2">
          <p className="text-sm text-text-primary">{customer.deliveryAddress.street}</p>
          <p className="text-sm text-text-primary">
            {customer.deliveryAddress.postalCode} {customer.deliveryAddress.city}
          </p>
          <p className="text-sm text-text-primary">{customer.deliveryAddress.country}</p>
        </div>
      </div>

      <div className="p-4 bg-info-50 rounded-md border border-info-200">
        <div className="flex items-center mb-2">
          <Icon name="Info" size={16} className="text-info mr-2" />
          <span className="text-sm font-body-medium text-info">Información de Entrega</span>
        </div>
        <p className="text-sm text-text-secondary">
          Las entregas se realizan de lunes a viernes de 9:00 a 18:00. 
          Se requiere confirmación 24 horas antes de la entrega.
        </p>
      </div>
    </div>
  );

  const renderFinancialTab = () => (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="card p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-text-secondary">Total Pedidos</span>
            <Icon name="ShoppingCart" size={16} className="text-primary" />
          </div>
          <p className="text-2xl font-heading-semibold text-text-primary">{customer.totalOrders}</p>
        </div>
        <div className="card p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-text-secondary">Ingresos Totales</span>
            <Icon name="Euro" size={16} className="text-success" />
          </div>
          <p className="text-2xl font-heading-semibold text-success">{customer.totalRevenue}</p>
        </div>
      </div>

      <div>
        <label className="block text-sm font-body-medium text-text-secondary mb-2">
          Historial de Transacciones
        </label>
        <div className="space-y-2">
          <div className="flex items-center justify-between p-3 bg-secondary-50 rounded-md">
            <div className="flex items-center space-x-3">
              <Icon name="Receipt" size={16} className="text-success" />
              <div>
                <p className="text-sm font-body-medium text-text-primary">Última factura</p>
                <p className="text-xs text-text-muted">F-2025-0892</p>
              </div>
            </div>
            <span className="text-sm font-body-semibold text-success">€25,650</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-secondary-50 rounded-md">
            <div className="flex items-center space-x-3">
              <Icon name="FileText" size={16} className="text-primary" />
              <div>
                <p className="text-sm font-body-medium text-text-primary">Último presupuesto</p>
                <p className="text-xs text-text-muted">Q-2025-0245</p>
              </div>
            </div>
            <span className="text-sm font-body-semibold text-primary">€15,420</span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'contact':
        return renderContactTab();
      case 'billing':
        return renderBillingTab();
      case 'delivery':
        return renderDeliveryTab();
      case 'financial':
        return renderFinancialTab();
      default:
        return renderContactTab();
    }
  };

  return (
    <div className="card">
      {/* Header */}
      <div className="p-4 border-b border-border">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h2 className="text-lg font-heading-semibold text-text-primary mb-1">
              {customer.company}
            </h2>
            <p className="text-sm text-text-secondary">{customer.contactPerson}</p>
          </div>
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="p-2 text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-md transition-micro"
          >
            <Icon name={isEditing ? "X" : "Edit"} size={16} />
          </button>
        </div>

        <div className="flex flex-wrap gap-2">
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-body-medium border ${getStatusColor(customer.status)}`}>
            {customer.status}
          </span>
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-body-medium border ${getRelationshipColor(customer.relationshipStatus)}`}>
            {customer.relationshipStatus}
          </span>
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-body-medium border bg-secondary-100 text-text-secondary border-secondary-200">
            {customer.customerType}
          </span>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-border">
        <nav className="flex space-x-0">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-3 text-sm font-body-medium border-b-2 transition-micro ${
                activeTab === tab.id
                  ? 'border-primary text-primary bg-primary-50' :'border-transparent text-text-secondary hover:text-text-primary hover:bg-secondary-50'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="p-4">
        {renderTabContent()}
      </div>

      {/* Actions */}
      {isEditing && (
        <div className="p-4 border-t border-border bg-secondary-25">
          <div className="flex items-center justify-end space-x-3">
            <button
              onClick={() => setIsEditing(false)}
              className="px-4 py-2 text-sm font-body-medium text-text-secondary border border-border rounded-md hover:bg-secondary-50 transition-micro"
            >
              Cancelar
            </button>
            <button className="px-4 py-2 text-sm font-body-medium text-white bg-primary rounded-md hover:bg-primary-600 transition-micro">
              Guardar Cambios
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerProfile;